import styled, { keyframes, css } from "styled-components";

import ornament from "../../assets/images/ornament.png"; // <- adaugă asta
import ornament3 from "../../assets/images/ornament3.png"; // <- adaugă asta

/* Paletă & umbre */
const paper = "#fffdfa";
const ink = "#1e1b16";
const gold = "#c4a453";
const shadow = "rgba(0,0,0,0.20)";
const shadowDeep = "rgba(0,0,0,0.35)";

/* —————————— WRAP —————————— */
export const Wrap = styled.section`
  width: 100%;
  min-height: 100svh;
  display: grid;
  place-items: start center;

  padding: 32px 20px 56px;
  margin-top: 10px;

  @media (max-width: 720px) {
    place-items: center;
    min-height: 80svh;
    margin-top: 20px;
  }
`;

/* —————————— CARTEA —————————— */
export const Book = styled.div`
  position: relative;
  width: min(980px, 94vw);
  aspect-ratio: 3 / 1.7; /* fix desktop */
  perspective: 2200px;
  filter: drop-shadow(0 14px 28px ${shadowDeep});
  padding: 10px;
  overflow: visible;

  /* variabile comune */
  --page-radius: 18px;
  --bezel-gap: 8px;
  --ribbon-shift: 0px;
  --edge-w: 22px;
  --edge-round: 16px;

  @media (max-width: 720px) {
    width: 100%;
    max-width: 520px;
    height: clamp(520px, 70vh, 720px); /* fix mobil, fără scroll intern */
    aspect-ratio: auto;
    padding: 6px;
    filter: drop-shadow(0 10px 22px rgba(0, 0, 0, 0.28));
    --page-radius: 14px;
    --bezel-gap: 6px;
    --ribbon-shift: 120px;
  }
`;

/* —— Coperta */
const leather = "#0c0c0c";
const leatherHi = "#161616";
const leatherLo = "#070707";

export const Case = styled.div`
  position: absolute;
  inset: -14px;
  border-radius: 22px;
  background: radial-gradient(120% 90% at 50% 8%, ${leatherHi}, transparent 60%),
    radial-gradient(
      140% 100% at 50% 120%,
      rgba(255, 255, 255, 0.06),
      transparent 60%
    ),
    repeating-linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.02) 0 3px,
      transparent 3px 8px
    ),
    linear-gradient(${leather}, ${leatherLo});
  box-shadow: inset 0 0 0 2px #000, inset 0 0 0 3px rgba(255, 255, 255, 0.06),
    0 18px 28px ${shadowDeep};
  z-index: 0;

  &::after {
    content: "";
    position: absolute;
    inset: 10px;
    border-radius: 16px;
    box-shadow: inset 0 0 0 2px rgba(196, 164, 83, 0.55),
      inset 0 0 18px rgba(196, 164, 83, 0.18);
    pointer-events: none;
  }

  @media (max-width: 720px) {
    inset: -10px;
    border-radius: 18px;
    &::after {
      inset: 8px;
      border-radius: 14px;
    }
  }
`;

/* —— Colțare aurii */
export const Corner = styled.div`
  position: absolute;
  width: 32px;
  height: 32px;
  z-index: 3;
  filter: drop-shadow(0 4px 8px ${shadowDeep});

  ${(p) => p.$pos === "tl" && "top:-6px; left:-6px;"}
  ${(p) => p.$pos === "tr" && "top:-6px; right:-6px; transform: scaleX(-1);"}
  ${(p) => p.$pos === "bl" && "bottom:-6px; left:-6px; transform: scaleY(-1);"}
  ${(p) => p.$pos === "br" && "bottom:-6px; right:-6px; transform: scale(-1);"}

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: radial-gradient(
        160% 160% at 0% 0%,
        rgba(255, 255, 255, 0.55),
        transparent 40%
      ),
      radial-gradient(
        120% 120% at 100% 100%,
        rgba(0, 0, 0, 0.35),
        transparent 40%
      ),
      linear-gradient(135deg, ${gold}, #b6913e);
    clip-path: polygon(0 0, 100% 0, 0 100%);
    border-radius: 6px;
  }

  @media (max-width: 720px) {
    width: 26px;
    height: 26px;
  }
`;

/* —— Cotor exterior (edge) */
export const Edge = styled.div`
  position: absolute;
  top: -8px;
  bottom: -8px;
  width: 26px;
  z-index: 0;

  ${(p) =>
    p.$side === "left"
      ? "left:-26px; border-radius:16px 0 0 16px;"
      : "right:-26px; border-radius:0 16px 16px 0;"}

  background:
    linear-gradient(${(p) => (p.$side === "left" ? "to left" : "to right")},
      rgba(0,0,0,0.25), transparent 60%),
    repeating-linear-gradient(0deg,#f2e9dc 0px,#f2e9dc 1.5px,#e6dccc 1.5px,#e6dccc 3px);
  box-shadow: inset 0 0 14px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(0, 0, 0, 0.08);

  &::before,
  &::after {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: inherit;
  }
  &::before {
    background: repeating-linear-gradient(
        6deg,
        rgba(0, 0, 0, 0.12) 0 1px,
        transparent 1px 2.8px
      ),
      repeating-linear-gradient(
        2deg,
        rgba(0, 0, 0, 0.08) 0 1px,
        transparent 1px 2.2px
      ),
      repeating-linear-gradient(
        0deg,
        rgba(0, 0, 0, 0.05) 0 1px,
        transparent 1px 2px
      );
    mix-blend-mode: multiply;
    opacity: 0.95;
  }
  &::after {
    background: radial-gradient(
        120% 50% at 0% 50%,
        rgba(0, 0, 0, 0.18),
        transparent 65%
      ),
      radial-gradient(
        120% 120% at 50% 50%,
        rgba(0, 0, 0, 0.08),
        transparent 60%
      );
    ${(p) => p.$side === "right" && "transform:scaleX(-1);"}
    opacity:.55;
  }

  @media (max-width: 720px) {
    width: 20px;
    ${(p) =>
      p.$side === "left"
        ? "left:-20px; border-radius:14px 0 0 14px;"
        : "right:-20px; border-radius:0 14px 14px 0;"}
  }
`;

/* —— Panglică */
export const Ribbon = styled.div`
  position: absolute;
  top: -8px;
  left: calc(50% - 12px + var(--ribbon-shift, 0px));
  width: 24px;
  height: 56px;
  z-index: 6;
  pointer-events: none;
  background: linear-gradient(#e93a3a, #b10e0e);
  clip-path: polygon(0 0, 100% 0, 100% 80%, 50% 100%, 0 80%);
  filter: drop-shadow(0 6px 10px ${shadowDeep});
  opacity: 0.96;

  @media (max-width: 720px) {
    height: 44px;
  }
`;

/* —————————— SPREAD —————————— */
export const Spread = styled.div`
  position: relative;
  z-index: 4;
  width: 100%;
  height: 100%;
  border-radius: 18px;
  background: linear-gradient(90deg, #e5dccf 0%, #eae2d7 50%, #e5dccf 100%);
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: clamp(6px, 0.8vw, 10px);
  overflow: hidden;
  cursor: grab;
  user-select: none;

  &:active {
    cursor: grabbing;
  }

  &::before {
    position: absolute;
    inset: 0;
    pointer-events: none;
    background: radial-gradient(
        140px 22px at 50% 0%,
        rgba(0, 0, 0, 0.35),
        rgba(0, 0, 0, 0.18) 40%,
        rgba(0, 0, 0, 0.04) 75%,
        transparent 100%
      ),
      radial-gradient(
        140px 22px at 50% 100%,
        rgba(0, 0, 0, 0.35),
        rgba(0, 0, 0, 0.18) 40%,
        rgba(0, 0, 0, 0.04) 75%,
        transparent 100%
      ),
      radial-gradient(
        140% 120% at 50% 50%,
        rgba(0, 0, 0, 0.3) 0%,
        rgba(0, 0, 0, 0.18) 18%,
        rgba(0, 0, 0, 0.1) 36%,
        rgba(0, 0, 0, 0.04) 56%,
        transparent 62%
      ),
      linear-gradient(
        to right,
        transparent 49%,
        rgba(255, 255, 255, 0.55) 50%,
        transparent 51%
      ),
      repeating-linear-gradient(
        90deg,
        rgba(0, 0, 0, 0.06) 0 1px,
        rgba(0, 0, 0, 0) 1px 3px
      ),
      linear-gradient(
        to right,
        rgba(0, 0, 0, 0.12),
        transparent 9% 91%,
        rgba(0, 0, 0, 0.12)
      );
    mask: radial-gradient(120% 100% at 50% 50%, #000 0 40%, transparent 55%);
    -webkit-mask: radial-gradient(
      120% 100% at 50% 50%,
      #000 0 40%,
      transparent 55%
    );
    mix-blend-mode: multiply;
    content: "";
  }

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(to right, rgba(0, 0, 0, 0.07), transparent 6%),
      linear-gradient(to left, rgba(0, 0, 0, 0.07), transparent 6%);
    mix-blend-mode: multiply;
    pointer-events: none;
  }

  @media (max-width: 720px) {
    border-radius: 12px;
    grid-template-columns: 1fr;
    gap: 0;
  }
`;

/* —————————— PAGINI —————————— */
export const Page = styled.article`
  position: relative;
  z-index: 5;
  background: ${paper};
  color: ${ink};
  border-radius: 14px;
  overflow: hidden;
  transform-style: preserve-3d;
  isolation: isolate;

  background-image: radial-gradient(
      circle at 20% 10%,
      rgba(0, 0, 0, 0.03),
      transparent 45%
    ),
    repeating-linear-gradient(
      0deg,
      transparent,
      transparent 30px,
      rgba(0, 0, 0, 0.02) 31px
    );

  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.18),
    0 2px 0 rgba(255, 255, 255, 0.5) inset, 0 0 0 1px rgba(0, 0, 0, 0.05) inset;

  ${(p) =>
    p.$side === "left"
      ? css`
          box-shadow: 0 10px 26px rgba(0, 0, 0, 0.18),
            inset -10px 0 20px -15px ${shadow},
            inset -18px 0 18px -16px rgba(0, 0, 0, 0.25),
            0 2px 0 rgba(255, 255, 255, 0.5) inset,
            0 0 0 1px rgba(0, 0, 0, 0.05) inset;
          &::before {
            content: "";
            position: absolute;
            top: 0;
            bottom: 0;
            left: -1px;
            width: 18px;
            background: radial-gradient(
                80% 100% at 100% 50%,
                rgba(0, 0, 0, 0.2),
                transparent 70%
              ),
              linear-gradient(90deg, rgba(196, 164, 83, 0.35), transparent 70%);
            pointer-events: none;
          }
        `
      : css`
          box-shadow: 0 10px 26px rgba(0, 0, 0, 0.18),
            inset 10px 0 20px -15px ${shadow},
            inset 18px 0 18px -16px rgba(0, 0, 0, 0.25),
            0 2px 0 rgba(255, 255, 255, 0.5) inset,
            0 0 0 1px rgba(0, 0, 0, 0.05) inset;
          &::before {
            content: "";
            position: absolute;
            top: 0;
            bottom: 0;
            right: -1px;
            width: 18px;
            background: radial-gradient(
                80% 100% at 0% 50%,
                rgba(0, 0, 0, 0.2),
                transparent 70%
              ),
              linear-gradient(270deg, rgba(196, 164, 83, 0.35), transparent 70%);
            pointer-events: none;
          }
        `}

  ${(p) =>
    p.$hiddenDuringFlip &&
    css`
      opacity: 0;
      transition: opacity 0.12s ease;
    `}

  @media (max-width: 720px) {
    ${(p) =>
      p.$side === "right" &&
      css`
        display: none;
      `}
    ${(p) =>
      p.$side === "left" &&
      css`
        border-radius: 12px;
        height: 100%;
        box-shadow: 0 10px 22px rgba(0, 0, 0, 0.16);
        &::before {
          display: none;
        }
      `}
  }
`;

/* —— Peek în timpul flip-ului */
export const PeekFlip = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 50%;
  ${(p) => (p.$side === "left" ? "left:0;" : "left:50%;")}
  background: ${paper};
  border-radius: ${(p) =>
    p.$side === "left" ? "0 14px 14px 0" : "14px 0 0 14px"};
  overflow: hidden;
  pointer-events: none;
  z-index: 6;
  opacity: 0.6;
  box-shadow: ${(p) =>
    p.$side === "left"
      ? `inset -10px 0 18px -14px ${shadowDeep}`
      : `inset 10px 0 18px -14px ${shadowDeep}`};

  @media (max-width: 720px) {
    top: 0;
    left: 0 !important;
    right: 0;
    width: 100% !important;
    border-radius: 12px !important;
  }
`;

export const PageInner = styled.div`
  position: relative;
  height: 100%;
  padding: clamp(16px, 2vw, 26px);
  display: flex;
  flex-direction: column;

  /* Card fără imagine: ocupă toată lățimea, fără coloana de thumb */
  li .card.no-thumb {
    grid-template-columns: 1fr; /* elimină coloana pentru thumb */
  }

  h2 {
    font-family: "Cormorant Garamond", serif;
    font-weight: 700;
    font-size: clamp(22px, 2.1vw, 30px);
    letter-spacing: 0.5px;
    margin: 0px 0 4px;
    color: ${ink};
    text-align: center;
    position: relative;
    &::after {
      content: "";
      display: block;
      width: 120px;
      height: 14px;
      margin: 8px auto 6px;
      background-image: var(--ornament-url, none);
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      opacity: 0.65;
      filter: drop-shadow(0 0.5px 0 rgba(0, 0, 0, 0.15));
    }
    &::before {
      content: "";
      display: block;
      width: 140px;
      height: 1px;
      margin: 0 auto 8px;
      background: linear-gradient(
        90deg,
        transparent,
        rgba(0, 0, 0, 0.25),
        transparent
      );
      opacity: 0.6;
    }
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: grid;
    gap: clamp(8px, 0.9vw, 12px);
  }

  /* card produs: thumb mic + meta */
  li .card {
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: start; /* în loc de center */
    gap: clamp(10px, 1.2vw, 14px);
    padding: clamp(8px, 1.4vw, 12px);
    border-radius: 12px;
    background: #fffcf6;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08),
      0 0 0 1px rgba(0, 0, 0, 0.04) inset;
  }

  /* thumb 4:3 */
  li .thumb {
    --thumb-w: clamp(110px, 14vw, 140px);
    width: var(--thumb-w);
    aspect-ratio: 4 / 3;
    border-radius: 12px;
    overflow: hidden;
    background: #f6f2ea;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);
  }
  li .thumb img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transform: translateZ(0);
  }

  /* meta + titlu + preț pe același rând */
  li .meta {
    min-width: 0;
  }
  li .titleRow {
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: baseline;
    gap: 10px;
    font-weight: 700;
    font-size: clamp(14px, 1.2vw, 18px);
  }
  li .name {
    white-space: nowrap;
  }
  li .dots {
    border-bottom: 1px dotted rgba(0, 0, 0, 0.28);
    align-self: end;
    transform: translateY(-1.5px);
    opacity: 0.9;
  }
  li .price {
    font-variant-numeric: tabular-nums;
    color: ${gold};
    text-shadow: 0 0.5px 0 rgba(0, 0, 0, 0.15);
  }
  li .descWrap {
    font-size: 0rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  li .desc {
    font-size: 0.9rem;
  }

  li .moreHint {
    font-size: 11px;
    font-style: italic;
    color: #c4a453;
    text-align: right;
    align-self: flex-end; /* împinge textul spre dreapta cardului */
  }

  &::after {
    content: "";
    position: absolute;
    right: 10px;
    bottom: 8px;
    width: 72px;
    height: 10px;
    background-image: var(--ornament-url, none);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: right bottom;
    opacity: 0.14;
    pointer-events: none;
  }

  @media (max-width: 720px) {
    padding: clamp(5px, 2vw, 1px);
    h2 {
      margin: 20px 0 4px;
    }

    /* ingredientele în dreapta imaginii */
    li .descWrap {
      grid-area: desc;
      margin-top: 4px;
      min-width: 0;
    }

    li .desc {
      font-size: 0.7rem;
    }

    li .moreHint {
      font-size: 9px;
      margin-top: 2px;
      margin-right: 9px;
      /* align-self și text-align vin din stilul de bază,
         deci îl ai deja la dreapta sub ingrediente */
    }
    /* grid: rând 1 = titlu, rând 2 = poză stânga / ingrediente dreapta */
    li .card {
      display: grid;
      grid-template-columns: minmax(120px, 42vw) 1fr;
      grid-template-rows: auto auto;
      grid-template-areas:
        "title title"
        "thumb desc";
      align-items: start; /* în loc de center */
      padding: 12px;
    }

    /* cheia! – „dizolvăm” .meta ca să poată copiii ei folosi ariile grilei */
    li .meta {
      display: contents;
      min-width: 0; /* previne overflow pe coloana descrierii */
    }

    /* titlul + preț pe rândul de sus */
    li .titleRow {
      grid-area: title;
      display: grid;
      grid-template-columns: auto 1fr auto;
      gap: 8px;
      align-items: baseline;
      font-size: clamp(15px, 4.4vw, 18px);
    }

    /* nu mai tăiem numele cu „…” */
    li .name {
      white-space: normal;
      overflow: visible;
      text-overflow: clip;
      max-width: none;
    }

    /* THE DOTTED LEADER */
    li .dots {
      height: 0; /* no extra height */
      border-bottom: 1px dotted rgba(0, 0, 0, 0.28);
      align-self: end; /* align with last line of the name */
      transform: translateY(-1px);
      opacity: 0.9;
    }

    /* imaginea în stânga jos */
    li .thumb {
      grid-area: thumb;
      width: 100%;
      max-width: 300px;
      aspect-ratio: 4 / 3;
      border-radius: 9px;
    }
    ul {
      gap: clamp(17px);
    }
  }
  /* —— Desktop: păstrăm punctele și lăsăm titlul pe 2+ rânduri —— */
  @media (min-width: 721px) {
    li .titleRow {
      grid-template-columns: auto 1fr auto; /* nume | puncte | preț */
    }
    li .name {
      white-space: normal; /* override la nowrap-ul din baza desktop */
      overflow: visible;
      text-overflow: clip;
      line-height: 1.18;
    }
    li .dots {
      height: 0; /* nu adaugă înălțime */
      border-bottom: 1px dotted rgba(0, 0, 0, 0.28); /* punctele rămân vizibile */
      align-self: end;
      transform: translateY(-2px); /* reglaj optic */
      opacity: 0.9;
    }
    li .price {
      white-space: nowrap;
      font-variant-numeric: tabular-nums;
    }
  }
`;

export const PageNumber = styled.div`
  margin-top: auto;
  align-self: center;
  font-family: "Cormorant Garamond", serif;
  letter-spacing: 3px;
  font-size: clamp(12px, 1vw, 14px);
  color: rgba(0, 0, 0, 0.55);
  @media (max-width: 720px) {
    font-size: 12px;
    opacity: 0.7;
  }
`;

export const PageShadow = styled.div`
  pointer-events: none;
  position: absolute;
  inset: 0;
  background: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0.05),
    transparent 30% 70%,
    rgba(0, 0, 0, 0.05)
  );
  mix-blend-mode: multiply;
  opacity: 0.35;
`;

/* —————————— BUTOANE —————————— */
export const SideButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: 0;
  background: ${ink};
  color: ${paper};
  font-weight: 800;
  box-shadow: 0 8px 18px ${shadowDeep};
  display: grid;
  place-items: center;
  cursor: pointer;
  transition: transform 0.15s ease, opacity 0.2s ease, box-shadow 0.2s ease;
  z-index: 7;

  &:hover {
    transform: translateY(-50%) scale(1.05);
  }
  &:disabled {
    opacity: 0.35;
    cursor: not-allowed;
    box-shadow: none;
  }

  ${(p) => (p.$pos === "left" ? "left:-10px;" : "right:-10px;")}

  @media (max-width: 720px) {
    width: 36px;
    height: 36px;
    box-shadow: 0 4px 10px ${shadowDeep};
  }
`;

/* —————————— FLIP —————————— */
const flipNext = keyframes`0%{transform:rotateY(0)}45%{transform:rotateY(-100deg)}100%{transform:rotateY(-180deg)}`;
const flipPrev = keyframes`0%{transform:rotateY(0)}45%{transform:rotateY(100deg)}100%{transform:rotateY(180deg)}`;
const flipMobileNext = keyframes`0%{transform:rotateY(0);filter:brightness(1)}45%{transform:rotateY(-105deg);filter:brightness(.96)}100%{transform:rotateY(-180deg);filter:brightness(.92)}`;
const flipMobilePrev = keyframes`0%{transform:rotateY(0);filter:brightness(1)}45%{transform:rotateY(105deg);filter:brightness(.96)}100%{transform:rotateY(180deg);filter:brightness(.92)}`;

export const FlipOverlay = styled.div`
  position: absolute;
  z-index: 7;
  top: 0;
  bottom: 0;
  pointer-events: none;
  background: ${paper};
  overflow: hidden;
  transform-style: preserve-3d;
  will-change: transform;
  box-shadow: inset 10px 0 20px -10px ${shadowDeep}, 0 6px 18px ${shadowDeep};

  ${(p) =>
    p.$dir === "next"
      ? css`
          left: 50%;
          width: 50%;
          transform-origin: left center;
          border-radius: 14px 0 0 14px;
          animation: ${flipNext} 0.65s ease both;
        `
      : css`
          left: 0;
          width: 50%;
          transform-origin: right center;
          border-radius: 0 14px 14px 0;
          animation: ${flipPrev} 0.65s ease both;
        `}

  .face {
    position: absolute;
    inset: 0;
    backface-visibility: hidden;
  }
  .face.front {
    transform: rotateY(0);
  }
  .face.back {
    transform: rotateY(180deg);
  }
  .face.back > * {
    transform: scaleX(-1);
  }

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(
      90deg,
      rgba(0, 0, 0, 0.14),
      transparent 25% 75%,
      rgba(0, 0, 0, 0.22)
    );
    mix-blend-mode: multiply;
    pointer-events: none;
  }
  ${(p) =>
    p.$dir === "prev" &&
    css`
      &::after {
        background: linear-gradient(
          90deg,
          rgba(0, 0, 0, 0.22),
          transparent 25% 75%,
          rgba(0, 0, 0, 0.14)
        );
      }
    `}

  @media (max-width: 720px) {
    left: 0 !important;
    width: 100% !important;
    border-radius: 12px !important;
    box-shadow: inset 12px 0 18px -10px ${shadowDeep}, 0 6px 16px ${shadowDeep};
    ${(p) =>
      p.$dir === "next"
        ? css`
            transform-origin: right center !important;
            animation: ${flipMobileNext} 0.65s ease both !important;
          `
        : css`
            transform-origin: left center !important;
            animation: ${flipMobilePrev} 0.65s ease both !important;
          `}
  }
`;

/* —— Gutter decor (opțional) */
export const GutterLip = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: clamp(6px, 0.8vw, 10px);
  width: 180px;
  height: 34px;
  pointer-events: none;
  z-index: 0;
  mix-blend-mode: multiply;
  background: radial-gradient(
      90px 26px at 50% 100%,
      rgba(0, 0, 0, 0.35) 0%,
      rgba(0, 0, 0, 0.18) 45%,
      rgba(0, 0, 0, 0.07) 78%,
      transparent 100%
    ),
    linear-gradient(to top, rgba(0, 0, 0, 0.18), transparent 70%);
  -webkit-mask: radial-gradient(
      14px 14px at calc(50% - 14px) 100%,
      #000 98%,
      transparent 100%
    ),
    radial-gradient(
      14px 14px at calc(50% + 14px) 100%,
      #000 98%,
      transparent 100%
    ),
    linear-gradient(#000, #000);
  mask: radial-gradient(
      14px 14px at calc(50% - 14px) 100%,
      #000 98%,
      transparent 100%
    ),
    radial-gradient(
      14px 14px at calc(50% + 14px) 100%,
      #000 98%,
      transparent 100%
    ),
    linear-gradient(#000, #000);
`;

/* —————————— Intro (fără scroll pe mobil) —————————— */
export const IntroWrap = styled.div`
  display: grid;
  place-items: center;
  width: 100%;
`;
export const IntroTitle = styled.h2`
  text-align: center;
  margin: 6px 0 16px;
`;
export const IntroList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 10px;
`;
export const IntroButton = styled.button`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: #111;
  color: ${paper};
  border: 0;
  border-radius: 10px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 8px 18px ${shadowDeep};
  transition: transform 0.12s ease, box-shadow 0.2s ease, opacity 0.2s ease;
  &:hover {
    transform: translateY(-1px);
  }
  &:active {
    transform: translateY(0);
  }
  strong {
    color: ${gold};
    margin-left: 4px;
  }
  @media (max-width: 720px) {
    padding: 10px 1px;
  }
`;

/* —————————— Modal —————————— */
export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.45);
  display: grid;
  place-items: center;
  cursor: pointer;
`;
export const ModalCard = styled.div`
  position: relative;
  width: min(1100px, calc(100vw - 44px));
  max-height: 92vh;
  overflow: visible;
  padding-inline: 34px;
  margin: 30px auto 0;
  border-radius: 18px;
  background: transparent;
  pointer-events: auto;

  @media (max-width: 720px) {
    margin-top: -25px;
    width: calc(108vw - 32px);
    padding-inline: 28px;
  }
`;
export const ModalHeader = styled.div`
  position: fixed;
  top: calc(var(--site-header-h, 56px) + 12px + env(safe-area-inset-top));
  right: calc(16px + env(safe-area-inset-right));
  z-index: 9999;
  pointer-events: none;

  @media (max-width: 720px) {
    top: calc(var(--site-header-h, 56px) + 8px + env(safe-area-inset-top));
    right: calc(12px + env(safe-area-inset-right));
  }
`;
export const ModalTitle = styled.div`
  pointer-events: none;
  color: #fff;
  font-weight: 700;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.6);
  display: none;
`;
export const ModalClose = styled.button`
  pointer-events: all;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  border: 0;
  border-radius: 50%;
  width: 42px;
  height: 42px;
  display: grid;
  place-items: center;
  font-size: 20px;
  line-height: 1;
  box-shadow: 0 6px 14px ${shadowDeep};
  cursor: pointer;
  transition: transform 0.12s ease, opacity 0.2s ease;
  &:hover {
    transform: scale(1.08);
  }
`;

export const Ornament = styled.div`
  height: 39px;
  background: url(${ornament3}) no-repeat center;
  background-size: contain;

  @media (max-width: 940px) {
    background: url(${ornament}) no-repeat center;
    height: 42px;
    background-size: contain;
  }
`;
